/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any */
/* tslint:disable */
// @ts-nocheck
// What's with all the above disables?
//  this is what a legacy 7 year old codebase looks like.
import { Grid } from '@elliemae/ds-grid';
import { styled, withTheme } from '@elliemae/ds-system';
import { noop } from 'lodash-es';
import { useCallback, useState } from 'react';

const StyledContainer = styled(Grid)`
  cursor: pointer;
  background: ${(props) => (props.touching ? props.theme.colors.brand['100'] : props.theme.colors.neutral['000'])};
  &:focus {
    position: relative;
    &:after {
      position: absolute;
      content: '';
      border: 2px solid brand-700;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
`;

const MobileTouchable = ({
  children,
  onClick = noop,
  theme,
  dataTestid = 'mobile-touchable',
  render,
  innerRef,
  ...gridProps
}) => {
  const [touching, setTouching] = useState(false);
  const handleStart = useCallback(() => setTouching(true), []);
  const handleEnd = useCallback(() => setTouching(false), []);
  return (
    <StyledContainer
      {...gridProps}
      touching={touching}
      onClick={onClick}
      onTouchStart={handleStart}
      onTouchEnd={handleEnd}
      data-testid={dataTestid}
      innerRef={innerRef}
      tabIndex={0}
    >
      {children || render(gridProps)}
    </StyledContainer>
  );
};

const DSMobileTouchable = withTheme(MobileTouchable);

export { DSMobileTouchable };
